export const ROLE_LABELS = {
  owner: "Owner",
  operations_manager: "Operations Manager",
  coordination: "Coordination",
  translator_cashier: "Translator / Cashier",
  medical_secretary: "Medical Secretary",
  supervising_dentist: "Supervising Dentist",
  treating_dentist: "Treating Dentist",
  general_accountant: "General Accountant",
  laboratory_coordinator: "Laboratory Coordinator",
  laboratory_technician: "Laboratory Technician",
  driver: "Driver",
};

export const STAGE_LABELS = {
  registration: "Registration",
  preliminary_quotation: "Preliminary Quotation",
  travel_planning: "Travel Planning",
  arrival: "Arrival",
  reception: "Reception",
  medical_examination: "Medical Examination",
  treatment_plan_approved: "Treatment Plan Approved",
  dentist_assigned: "Dentist Assigned",
  appointments: "Appointments",
  laboratory_production: "Laboratory Production",
  treatment: "Treatment",
  payments: "Payments",
  ready_for_pickup: "Ready for Pickup",
  driver_notified: "Driver Notified",
  transportation: "Transportation",
  follow_up: "Follow-up",
  completed: "Completed",
};

export function eur(n) {
  return new Intl.NumberFormat("en-IE", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n || 0);
}
